import { render } from "./Nokp.vue?vue&type=template&id=4601515a"
import script from "./Nokp.vue?vue&type=script&lang=js"
export * from "./Nokp.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__